export default class ItemAction {

    constructor() {
        this.animationType = undefined; // AnimationType
        this.animationDuration = 0.0;
        this.animationRepeat = false;
    }

}
